import React from 'react';
import { getLocale, useIntl } from 'umi';
import { Button } from 'tea-component';
import { LANGUAGE_EN, LANGUAGE_CN } from '@/pages/home/_config/config';
import CardSlot from '@/pages/intelligence/components/CardSlot';

import type { IBaseProps } from '@/pages/intelligence/types/common';

import './index.scss';

type IAddHandler = (e?: React.MouseEvent<Element, MouseEvent>) => void;

interface INoEntityCardProps extends IBaseProps {
  title?: any;
  onAdd: IAddHandler;
  isCompareGameSelection?: boolean;
}

export default function NoEntityCard(props: INoEntityCardProps) {
  const { formatMessage } = useIntl();

  const locale = getLocale();

  const {
    title = formatMessage({ id: 'dbi_games' }),
    onAdd,
    isCompareGameSelection = false,
  } = props;

  const handleAdd: IAddHandler = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    onAdd?.(e);
  };

  return (
    <CardSlot title={title} className="dbi-compare-no-data-card" iconList={[]}>
      <div className="dbi-no-data">
        {isCompareGameSelection ? (
          <>
            {formatMessage({ id: 'dbi_no_data_please_add' })}
            <Button className="dbi-btn" type="link" onClick={handleAdd}>
              {formatMessage({ id: 'dbi_game_selection' })}
            </Button>
          </>
        ) : (
          <>
            {locale === LANGUAGE_EN && (
              <>
                {`You haven't added a game yet, so` + ' '}
                <Button className="dbi-btn" type="link" onClick={handleAdd}>
                  Add Games
                </Button>{' '}
                now!
              </>
            )}
            {locale === LANGUAGE_CN && (
              <>
                您还没有添加游戏，
                <Button className="dbi-btn" type="link" onClick={handleAdd}>
                  请添加游戏！
                </Button>
              </>
            )}
          </>
        )}
      </div>
    </CardSlot>
  );
}
